module.exports = __webpack_public_path__ + "static/media/Angelo_Maniaol.d663e856.png";